var _a, _b, _c;
import { optionsMap, flattenObject } from 'pro-gallery-lib';
import { PLACEMENT_TO_TEXT_POSITION_MAP, PLACEMENT_TO_FLEX_MAP, } from '../consts';
import withDraggableOrder from './info/withDraggableOrder';
export var INFO = {
    WIDTH_IN_PIXEL: "controllers_layoutParams_info_width__pixel",
    WIDTH_IN_PERCENT: "controllers_layoutParams_info_width_percent",
    VERTICAL_ALIGN: "controllers_layoutParams_info_verticalAlignment",
    HORIZONTAL_ALIGN: "controllers_layoutParams_info_horizontalAlignment",
    VERTICAL_PADDING: "controllers_layoutParams_info_verticalPadding",
    HORIZONTAL_PADDING: "controllers_layoutParams_info_horizontalPadding",
    ALLOW_TITLE: "controllers_layoutParams_info_allowTitle",
    ALLOW_DESCRIPTION: "controllers_layoutParams_info_allowDescription",
    ALLOW_TITLE_AND_DESCRIPTION: "controllers_layoutParams_info_allowTitleAndDescription",
    EXTERNAL_MASTER_INFO_ENABLED: "controllers_layoutParams_infoElementOptions_external_enabled",
    EXTERNAL_MASTER_INFO_ORDER: "controllers_layoutParams_infoElementOptions_external_order",
    INTERNAL_MASTER_INFO_ENABLED: "controllers_layoutParams_infoElementOptions_internal_enabled",
    INTERNAL_MASTER_INFO_ORDER: "controllers_layoutParams_infoElementOptions_internal_order",
};
export var ExternalMasterInfoOption = (_a = createMasterInfoOption(INFO.EXTERNAL_MASTER_INFO_ORDER, INFO.EXTERNAL_MASTER_INFO_ENABLED), _a[0]), ExternalMasterInfoOptionEnabledKey = _a[1];
export var InternalMasterInfoOption = (_b = createMasterInfoOption(INFO.INTERNAL_MASTER_INFO_ORDER, INFO.INTERNAL_MASTER_INFO_ENABLED), _b[0]), InternalMasterInfoOptionEnabledKey = _b[1];
function getFlattenedWithDraggable(internalOrExternal, option) {
    return withDraggableOrder(option, function (order) {
        var _a;
        var fixedOrder = {
            top: order.top.join(','),
            middle: order.middle.join(','),
            bottom: order.bottom.join(','),
        };
        return flattenObject({
            infoElementsOptions: (_a = {}, _a[internalOrExternal] = { order: fixedOrder }, _a),
        });
    });
}
function getEnabledHandler(internalOrExternal) {
    return function (value) {
        var _a;
        try {
            var enabledData = value.split(',');
            var enabledObj = {
                enabled: {
                    Title: enabledData.includes('Title'),
                    Description: enabledData.includes('Description'),
                },
            };
            return flattenObject({
                infoElementsOptions: (_a = {}, _a[internalOrExternal] = enabledObj, _a),
            });
        }
        catch (e) {
            console.log('error parsing json', e);
            return {};
        }
    };
}
function createMasterInfoOption(key, enabledKey) {
    return [
        {
            key: key,
            enabledKey: enabledKey,
            title: 'Master Info',
            type: 'DRAGGABLE',
            options: [
                { type: 'section', key: 'top', label: 'top' },
                { type: 'section', key: 'middle', label: 'middle' },
                { type: 'section', key: 'bottom', label: 'bottom' },
                { type: 'item', key: 'Title', label: 'Title' },
                { type: 'item', key: 'Description', label: 'Description' },
            ],
            enabledKeyDefualt: 'Title,Description',
            controller: 'DRAGGABLE',
            default: 'top,Title,Description,middle,bottom',
        },
        {
            key: enabledKey,
            type: 'TEXT',
            title: '',
            default: 'Title,Description',
        },
    ];
}
export var INFO_CONTROLLERS = (_c = {},
    _c[INFO.WIDTH_IN_PIXEL] = function (value, options) {
        var _a;
        var unitSize = options[optionsMap.layoutParams.info.sizeUnits];
        if (unitSize !== 'PIXEL' || value === undefined) {
            return;
        }
        return _a = {},
            _a[optionsMap.layoutParams.info.width] = value,
            _a;
    },
    _c[INFO.EXTERNAL_MASTER_INFO_ENABLED] = getEnabledHandler('external'),
    _c[INFO.EXTERNAL_MASTER_INFO_ORDER] = getFlattenedWithDraggable('external', ExternalMasterInfoOption),
    _c[INFO.INTERNAL_MASTER_INFO_ENABLED] = getEnabledHandler('internal'),
    _c[INFO.INTERNAL_MASTER_INFO_ORDER] = getFlattenedWithDraggable('internal', InternalMasterInfoOption),
    _c[INFO.WIDTH_IN_PERCENT] = function (value, options) {
        var _a;
        var unitSize = options[optionsMap.layoutParams.info.sizeUnits];
        if (unitSize !== 'PERCENT' || value === undefined) {
            return;
        }
        return _a = {}, _a[optionsMap.layoutParams.info.width] = value, _a;
    },
    _c[INFO.ALLOW_TITLE] = 'allowTitle',
    _c[INFO.ALLOW_DESCRIPTION] = 'allowDescription',
    _c[INFO.VERTICAL_ALIGN] = 'galleryVerticalAlign',
    _c[INFO.HORIZONTAL_ALIGN] = function (value, _options) {
        if (value === undefined) {
            return;
        }
        return {
            galleryHorizontalAlign: PLACEMENT_TO_FLEX_MAP[value],
            galleryTextAlign: PLACEMENT_TO_TEXT_POSITION_MAP[value],
        };
    },
    _c[INFO.VERTICAL_PADDING] = 'textsVerticalPadding',
    _c[INFO.HORIZONTAL_PADDING] = 'textsHorizontalPadding',
    _c[INFO.ALLOW_TITLE_AND_DESCRIPTION] = function (value) {
        var allowTitle = value.includes(INFO.ALLOW_TITLE);
        var allowDescription = value.includes(INFO.ALLOW_DESCRIPTION);
        return {
            allowTitle: allowTitle,
            allowDescription: allowDescription,
        };
    },
    _c);
//# sourceMappingURL=info.js.map